import { render, staticRenderFns } from "./HelpManual.vue?vue&type=template&id=72d604b3"
import script from "./HelpManual.vue?vue&type=script&lang=js"
export * from "./HelpManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports